<script setup lang="ts">
import { PV } from "@/components";
import { ref, useId } from "vue";

const props = defineProps<{
    onUpdate: (active: boolean) => Promise<void>;
    disabled?: boolean;
}>();

const model = defineModel<boolean>({
    default: false,
});

const switchId = useId();
const disabled = ref(props.disabled ?? false);

async function onChange() {
    disabled.value = true;
    await props.onUpdate(model.value);
    disabled.value = false;
}
</script>

<template>
    <div class="flex flex-row gap-2 items-center justify-start">
        <PV.ToggleSwitch v-model="model" :disabled="disabled" :inputId="switchId" @change="onChange" />
    </div>
</template>
